export default __webpack_public_path__ + "static/media/PANTALLAZOS_2.c8629caa.jpg";